// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"521":"bd54ae16","883":"320f4579"}[chunkId] + ".chunk.js";
};